<template>
  <div class="file_frame">
    <span class="file-tip">{{ tip }}</span>
    <input
      :id="`_${name}`"
      type="file"
      style="display: none"
      @change="AddFileChangeEve"
    >
    <div class="file-wrap">
      <div
        v-for="(file,file_ind) in myfileArray"
        :key="file_ind"
        class="file"
      >
        <span v-if="file.type === 'file'">{{ file.file === '' ? file.fileName || `檔案${file_ind+1}`:file.file.name }}</span>
        <div
          v-if="file.type === 'img'"
          class="bg-img"
          :style="`background-image: url('${file.BS64 || file.expiringUrl || file.uploadUrl}')`"
          @click="index = file_ind"
        />
        <div class="optionBtn-wrap">
          <div
            class="btn"
            @click="ChangeFile(file_ind)"
          >
            更換
          </div>
          <div
            class="btn"
            @click="delFile(file_ind)"
          >
            刪除
          </div>
        </div>
      </div>
      <div
        v-if="addFileShow()"
        class="file file-plus"
        @click="AddFile()"
      >
        <i
          class="icon-plus"
          aria-hidden="true"
        />
        <span>新增{{ type ==='img'? '圖片':'檔案' }}</span>
      </div>
    </div>
    <CoolLightBox
      :items="images"
      :index="index"
      :slideshow="false"
      @close="index = null"
      @on-open="lightBoxOpen"
    />
  </div>
</template>
<script>
import { docFilenameExt, imgFilenameExt, allFilenameExt } from '../js/models'
import { getCompressQuality, compressImage } from '../js/utils'
export default {
  props: {
    type: {
      type: String,
      default: 'file'
    },
    filearray: Array,
    name: '',
    quantity: 0,
    showNote: {
      default: true,
      type: Boolean
    },
    acceptFileType: Array, // []:依據原本判斷檔案類別
    isAcceptFileSizeLimited: {
      type: Boolean, // 是否有限制檔案大小
      default: true // 預設會限制檔案大小（區權會不限制）
    }
  },
  data () {
    return {
      fileRechangeInd: -1,
      myfileArray: this.filearray,
      fileQuantity: this.quantity,
      fileSize: 'limit',
      images: [],
      index: null,
      compressQuality: null // 壓縮品質，預設 null 代表尚未取得
    }
  },
  computed: {
    tip () {
      // 提示文案
      switch (this.type) {
        case 'img':
          return `圖片最多可選擇 ${this.quantity} 個檔案，每個檔案大小限 4MB 以下；檔案類型可為：${this.finalAcceptFileTypeString}`
        case 'file':
          return `文件最多可選擇 ${this.quantity} 個檔案，每個檔案大小限 10MB 以下；檔案類型可為：${this.finalAcceptFileTypeString}`
        default:
          return `最多可選擇 ${this.quantity} 個檔案，每個檔案大小限 10MB 以下；檔案類型可為：${this.finalAcceptFileTypeString}`
      }
    },
    finalAcceptFileTypeArr () {
      // 可接受的檔案類型
      if (this.acceptFileType) {
        return this.acceptFileType
      } else {
        switch (this.type) {
          case 'file':
            return docFilenameExt
          case 'img':
            return imgFilenameExt
          default:
            return allFilenameExt
        }
      }
    },
    finalAcceptFileTypeString () {
      // 可接受的檔案類型字串
      return this.finalAcceptFileTypeArr.join('、')
    },
    finalMaxFileSize () {
      // 可接受的檔案大小
      if (this.isAcceptFileSizeLimited) {
        // 有限制
        switch (this.type) {
          case 'file':
            return 10485760 // 10MB = 10 * 1024 * 1024 bytes
          case 'img':
            return 4194304 // 4MB = 4 * 1024 * 1024 bytes
          default:
            return 10485760 // 10MB = 10 * 1024 * 1024 bytes
        }
      } else {
        // 無限制
        return Number.MAX_SAFE_INTEGER
      }
    }
  },
  watch: {
    filearray: {
      handler (newVal, oldVal) {
        this.myfileArray = newVal
        this.images = []
        this.lightboxData()
      },
      deep: true
    },
    myfileArray: {
      handler (newVal, oldVal) {
        this.$emit('on-fileArray-change', newVal)
      },
      deep: true
    }
  },
  methods: {
    AddFile () {
      let ErrMsg
      console.log(this.fileQuantity)
      if (this.myfileArray.length >= this.fileQuantity) {
        // 判斷筆數
        if (this.type === 'file') {
          ErrMsg = '文件最多為' + this.fileQuantity + '筆'
        } else if (this.type === 'img') {
          ErrMsg = '圖片最多為' + this.fileQuantity + '筆'
        } else {
          ErrMsg = '檔案最多為' + this.fileQuantity + '筆'
        }
        this.$alert(ErrMsg, '提示', {
          confirmButtonText: '確定',
          type: 'warning',
          callback: action => {
          }
        })
        return false
      }
      this.fileRechangeInd = -1
      document.getElementById(`_${this.name}`).click()
    },
    ChangeFile (ind) {
      this.fileRechangeInd = ind
      document.getElementById(`_${this.name}`).click()
    },
    async AddFileChangeEve (event) {
      const fileType = event.target.files[0].name.split('.')[event.target.files[0].name.split('.').length - 1].toLowerCase()
      const filesize = this.fileSize === 2 ? 1 : event.target.files[0].size // 若不限制檔案大小 fileSize = 1
      let ErrMsg
      if (this.finalAcceptFileTypeArr.indexOf(fileType) === -1) {
        // 判斷檔案類型
        if (this.type === 'file') {
          ErrMsg = '文件只允許 ' + this.finalAcceptFileTypeString
        } else if (this.type === 'img') {
          ErrMsg = '圖片只允許 ' + this.finalAcceptFileTypeString
        } else {
          ErrMsg = '檔案只允許 ' + this.finalAcceptFileTypeString
        }
        this.$alert(ErrMsg, '錯誤', {
          confirmButtonText: '確定',
          type: 'error',
          callback: action => {}
        })

        document.getElementById(`_${this.name}`).value = '' // 清空input file
        return false
      } else if (filesize > this.finalMaxFileSize) {
        // 判斷檔案大小
        if (this.type === 'file') {
          ErrMsg = '文件限制為 10MB 以下'
        } else if (this.type === 'img') {
          ErrMsg = '圖片限制為 4MB 以下'
        } else {
          ErrMsg = '檔案限制為 10MB 以下'
        }
        this.$alert(ErrMsg, '錯誤', {
          confirmButtonText: '確定',
          type: 'error',
          callback: action => {
          }
        })
        document.getElementById(`_${this.name}`).value = '' // 清空input file
        return false
      } else if (filesize === 0) {
        // 判斷檔案大小不可為0
        if (this.type === 'file') {
          ErrMsg = '文件不得為0KB'
        } else if (this.type === 'img') {
          ErrMsg = '圖片不得為0KB'
        } else {
          ErrMsg = '檔案不得為0KB'
        }
        this.$alert(ErrMsg, '錯誤', {
          confirmButtonText: '確定',
          type: 'error',
          callback: action => {
          }
        })
        document.getElementById(`_${this.name}`).value = '' // 清空input file
        return false
      }

      const splitDotArr = event.target.files[0].name.split('.')
      const fileExt = splitDotArr[splitDotArr.length - 1].toLowerCase()
      if (imgFilenameExt.includes(fileExt)) {
        let compressedImage
        if (this.compressQuality === null) {
          // 首次壓縮圖片時，取得壓縮品質設定
          this.compressQuality = await getCompressQuality()
        }
        try {
          compressedImage = await compressImage(event.target.files[0], this.compressQuality)
        } catch {
          compressedImage = event.target.files[0]
        }
        this.GetBS64(compressedImage, async (res) => {
          if (this.fileRechangeInd === -1) {
            // 新增圖片
            this.myfileArray.push({ type: 'img', file: compressedImage, uploadUrl: '', BS64: res })
          } else {
            // 替換圖片
            this.myfileArray[this.fileRechangeInd].file = compressedImage
            this.myfileArray[this.fileRechangeInd].uploadUrl = ''
            this.myfileArray[this.fileRechangeInd].BS64 = res
          }
          document.getElementById(`_${this.name}`).value = '' // 清空input file
        })
      } else {
        if (this.fileRechangeInd === -1) {
          // 新增檔案
          this.myfileArray.push({ type: 'file', file: event.target.files[0], uploadUrl: '' })
        } else {
          // 替換檔案
          this.myfileArray[this.fileRechangeInd].file = event.target.files[0]
          this.myfileArray[this.fileRechangeInd].uploadUrl = ''
        }
        document.getElementById(`_${this.name}`).value = '' // 清空input file
      }
    },
    delFile (ind) {
      this.myfileArray.splice(ind, 1)
    },
    GetBS64 (file, callback) {
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = function (e) {
        callback(this.result)
      }
    },
    addFileShow () {
      let flag = true
      if (this.fileQuantity === undefined || this.fileQuantity === 0) {
        flag = true
      } else {
        if (this.myfileArray.length < this.fileQuantity) {
          flag = true
        } else {
          flag = false
        }
      }
      return flag
    },
    lightboxData () {
      this.myfileArray.forEach(item => {
        if (item.type === 'img') {
          this.images.push(item.BS64 || item.expiringUrl || item.uploadUrl)
        }
      })
    },
    lightBoxOpen () {
      if (document.querySelector('.cool-lightbox-toolbar__btn[title="Show thumbnails"]')) { document.querySelector('.cool-lightbox-toolbar__btn[title="Show thumbnails"]').style.display = 'none' }
    }
  }
}
</script>
<style lang="sass" scoped>
  .file-wrap
    display: flex
    flex-wrap: wrap
    .file
      width: 150px
      height: 150px
      border: 1px solid $borderDark1
      color: #666
      border-radius: 8px
      cursor: pointer
      margin: 10px
      display: flex
      justify-content: center
      align-items: center
      flex-direction: column
      position: relative
      overflow: hidden
      &.error
        border: 1px solid #c44536
      &.success
        border: 1px solid #a5be00
      &:hover
        color: $mainFontColor
        border: 1px solid #aaa
        box-shadow: inset 0 1px 2px -1px rgba(0,0,0,.075), 0 0 8px rgba(120,120,120,.5)
        transition: .4s
        .optionBtn-wrap
          bottom: 0
      i
        font-size: 60px
      span
        font-size: 17px
        font-weight: 700
        width: 100%
        white-space: nowrap
        text-overflow: ellipsis
        overflow: hidden
        text-align: center
        margin-top: 10px
      .bg-img
        height: 100%
        width: 100%
        background-position: center
        background-size: cover
      .optionBtn-wrap
        display: flex
        position: absolute
        bottom: -30px
        width: 100%
        transition: .4s
        .btn
          width: 50%
          font-size: 17px
          font-weight: bold
          line-height: 30px
          text-align: center
          cursor: pointer
          background: -webkit-gradient( linear, left top, left bottom, color-stop(8%, #ededed), color-stop(97%, #dfdfdf) )
          background-color: #ededed
          &:first-child
            border-right: 1px solid #999
          &:hover
            filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#dfdfdf', endColorstr='#ededed')
            background: -webkit-gradient( linear, left top, left bottom, color-stop(8%, #dfdfdf), color-stop(97%, #ededed))
            background-color: #dfdfdf
    .file-plus
      border: 1px solid $mainColor
      color: $mainColor
      &:hover
        color: $mainColor
        border: 1px solid $mainColor
        box-shadow: inset 0 1px 2px -1px rgba(0,0,0,.075), 0 0 8px rgba(120,120,120,.5)
        transition: .4s
  .file-tip
    color: $subFontColor
    font-size: 14px
</style>
